export default __webpack_public_path__ + "static/media/Country-Grey.dafa365c.jpg";